import { render, staticRenderFns } from "./BriqSwitch.vue?vue&type=template&id=4d446720&scoped=true&lang=pug&"
import script from "./BriqSwitch.vue?vue&type=script&lang=js&"
export * from "./BriqSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BriqSwitch.vue?vue&type=style&index=0&id=4d446720&scoped=true&lang=stylus&"
import style1 from "./BriqSwitch.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d446720",
  null
  
)

export default component.exports